import { render, staticRenderFns } from "./CentralHeader.vue?vue&type=template&id=342c4d35&scoped=true&"
import script from "./CentralHeader.vue?vue&type=script&lang=js&"
export * from "./CentralHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c4d35",
  null
  
)

export default component.exports